<div class="grid mt-4">
	<div class="lg:col-8 md:col-8 sm:col-12 form">
		<p-panel>
			<ng-template pTemplate="header">
				<h1 class="text-white sp-marker mb-0 transition-all transition-duration-300 md:text-4xl text-2xl">
					{{'contact-us' | translate}}
				</h1>
			</ng-template>
			<div class="">
				<form #mailForm="ngForm">
					<div class="p-float-label mt-5" *ngIf="contacts && contacts.length > 0">
						<h4>Choisissez un contact</h4>
						<p-dropdown placeholder="Choisissez un thème" [options]="contacts" [(ngModel)]="mess.for" name="for"></p-dropdown>
					</div>
					<div class="p-float-label  mt-5">
						<input type="email" pInputText [(ngModel)]="mess.email" name="email" id="email" required class="w-full"> 
						<label for="email">{{'email' | translate}}</label>
					</div>
					<div class="p-float-label  mt-5">
						<input type="text" pInputText [(ngModel)]="mess.subject" name="subject" id="subject" required class="w-full"> 
						<label for="subject">{{'subject' | translate}}</label>
					</div>
					<div class="p-float-label  mt-5">
						<textarea [rows]="8" [(ngModel)]="mess.message" name="message" id="message" required class="w-full" pInputTextarea></textarea>
						<label for="message">{{'message' | translate}}</label>
					</div>
					<button (click)="send()" pButton [disabled]="mailForm.form.invalid">{{'Send mail' | translate}}</button>

				</form>
			</div>
		</p-panel>
	</div>
	<div class="lg:col-4 md:col-4 sm:col-12 flex flex-column justify-content-between">
		<div class="mb-2" *ngIf="!api.export">		
			<h1 class="mt-0 text-white sp-marker mb-0 transition-all transition-duration-300 md:text-4xl text-2xl">
				Blackrock Games
			</h1>
			6 Rue Edme Mariotte<br/> 63960 Veyre-Monton
		</div>
		<div class="mb-2" *ngIf="api.export">	
			Blackrock Games EXPORT<br />
			Regus Brussels Central Station<br />
			Blackrock Games International<br />
			Rue des colonies 11,<br />
			1000 BRUXELLES<br />BELGIUM
		</div>
		<div id="map-container" class="flex-grow-1">
			<div id="map" leaflet [leafletOptions]="options" class="w-full h-full" *ngIf="!api.loading">
			</div>
		</div>
	</div>
	<div class="col-12">
		<small *ngIf="!api.export">
			Les données personnelles collectées ci-dessus sont traitées par Blackrock Games et ses sous-traitants, afin de répondre à votre demande. Elles seront supprimées au plus tard un (1) an à compter de la réception de votre demande. Elles sont hébergées au sein de l’Union européenne et, lorsqu’elles sont susceptibles d’être transférées hors de l'Union Européenne, Blackrock Games s’assure que le traitement soit effectué en conformité avec la réglementation applicable. Vous pouvez demander l’accès, la rectification, la suppression et la portabilité de vos données personnelles ainsi que la limitation de leur traitement et définir des directives post mortem les concernant via le présent formulaire. Pour plus d’informations, veuillez consulter <a href='http://localhost:4200/pages/politique-de-confidentialite'>la charte données personnelles</a>
		</small>
		<small *ngIf="api.export">The personal data collected above is processed by Blackrock Games and its subcontractors in
		order to respond to your request. It will be deleted no later than one (1) year after receipt of your request. The data
		is hosted within the European Union and, when it may be transferred outside the European Union, Blackrock Games ensures
		that processing is carried out in accordance with applicable regulations. You may request access, rectification,
		deletion, and portability of your personal data, as well as restriction of processing and define post-mortem directives
		concerning it via this form. For more information, please consult <a
			href='http://localhost:4200/pages/politique-de-confidentialite'>the personal data policy</a>."
		</small>
	</div>
</div>